import React from 'react';
import axios from 'axios';
import { ReqAddDevice } from '../types/api/Devices';
import { ApiUrl } from '../conf/config';

export const useAddDevice = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const addDevice = (device: ReqAddDevice) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .post(`${ApiUrl}/admin/api/v1/devices`, device, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { addDevice, loading, error };
};
